import _ from 'lodash';
import { NOTIFICATION_DIALOG_PRIORITY } from 'Common/Constants';

import * as types from './types';
import {
  getActionsToDispatchOnOk,
  getActionsToDispatchOnCancel,
  getFunctionsToRunOnOk,
  getFunctionsToRunOnCancel,
} from './selectors';

export const addNotificationDialogs = dialogs => ({
  type: types.ADD_NOTIFICATION_DIALOGS,
  payload: dialogs.map(dialog => ({
    show: true,
    showCancel: false,
    actionsToDispatchOnOk: null,
    actionsToDispatchOnCancel: null,
    priority: NOTIFICATION_DIALOG_PRIORITY.LOWEST,
    ..._.mapKeys(dialog, (__, k) => _.camelCase(k)),
  })),
});

export const setNotificationDialog = ({
  type = null,
  title,
  message,
  show = true,
  showCancel = false,
  actionsToDispatchOnOk = null,
  actionsToDispatchOnCancel = null,
  functionsToRunOnOk = null,
  functionsToRunOnCancel = null,
  priority = NOTIFICATION_DIALOG_PRIORITY.LOWEST,
  okButtonText,
  ...rest
}) => ({
  type: types.SET_NOTIFICATION_DIALOG,
  payload: {
    type,
    message,
    title,
    show,
    showCancel,
    actionsToDispatchOnOk,
    actionsToDispatchOnCancel,
    functionsToRunOnOk,
    functionsToRunOnCancel,
    priority,
    okButtonText,
    ..._.mapKeys(rest, (__, k) => _.camelCase(k)),
  },
});

export const closeNotificationDialog = (index = 0, type = null) => ({
  type: types.CLOSE_NOTIFICATION_DIALOG,
  payload: { index, type },
});

export const notificationDialogOk = (index = 0) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const actionsToDispatch = getActionsToDispatchOnOk(state, index);
  const functionsToRun = getFunctionsToRunOnOk(state, index);
  /**
   * NOTE
   * closeNotificationDialog needs to be before the actionsToDispatch
   * The side effect of actionsToDispatch may create more dialogs
   */
  dispatch(closeNotificationDialog());
  if (Array.isArray(actionsToDispatch)) {
    actionsToDispatch.forEach(dispatch);
  }

  if (Array.isArray(functionsToRun)) {
    for (const f of functionsToRun) {
      await f();
    }
  }
};

export const notificationDialogCancel = (index = 0) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const actionsToDispatch = getActionsToDispatchOnCancel(state, index);
  const functionsToRun = getFunctionsToRunOnCancel(state, index);

  /**
   * NOTE
   * closeNotificationDialog needs to be before the actionsToDispatch
   * The side effect of actionsToDispatch may create more dialogs
   */
  dispatch(closeNotificationDialog());
  if (Array.isArray(actionsToDispatch)) {
    actionsToDispatch.forEach(dispatch);
  }

  if (Array.isArray(functionsToRun)) {
    for (const f of functionsToRun) {
      await f();
    }
  }
};

//Yes No Dialog
export const setYesNoDialogProps = props => {
  return {
    type: types.SET_YES_NO_DIALOG_PROPS,
    payload: props,
  };
};
export const resetYesNoDialog = () => {
  return {
    type: types.RESET_YES_NO_DIALOG_PROPS,
  };
};



// WEBPACK FOOTER //
// ./src/components/dialogs/state/actions.js